const DEFAULT_ENVIRONMENT = 'live-au';

const getAdyenEnvironment = (isProd, countryCode) => {
  if (!isProd) return 'test';

  const country = countryCode?.toUpperCase();

  if (!country) return DEFAULT_ENVIRONMENT;

  if (['AU', 'NZ'].includes(country)) return DEFAULT_ENVIRONMENT;
  if (['US', 'CA', 'MX'].includes(country)) return 'live-us';
  if (['SG', 'MY', 'ID', 'PH', 'TH', 'VN'].includes(country))
    return 'live-apse';
  if (['IN'].includes(country)) return 'live-in';

  return 'live';
};

export default getAdyenEnvironment;
